
import {Component, Vue} from 'vue-property-decorator';
import {mixins} from "vue-class-component";
import {abstractField} from "vue-form-generator";

@Component
    export default class PlaceholderField extends mixins(Vue, abstractField) {
    }
